import React, { FunctionComponent, useEffect, useState } from 'react'

import { useTranslation } from 'next-i18next'

import { LinkButtonProps } from 'src/components/LinkButton/LinkButton'
import { DataTestIds } from 'src/config/dataTestIds'
import useCountDown from 'src/hooks/useCountDown'

const useResend = ({
  resend,
  center,
  intervalInMinutes,
  label,
  fullWidth,
  Component,
  loading,
}: {
  resend: () => void
  intervalInMinutes: number
  label: string
  Component: FunctionComponent<LinkButtonProps>
  fullWidth?: boolean
  center?: boolean
  loading?: boolean
}) => {
  const [limited, setLimited] = useState<{
    manual: boolean
    at: number
  }>({ at: +new Date(), manual: false })

  const [error, setError] = useState('')

  const { t } = useTranslation()

  const [, , minutes, seconds] = useCountDown(limited.at + intervalInMinutes * 60 * 1000)

  const expired = minutes <= 0 && seconds <= 0

  const nextResendIn = `${minutes > 0 ? `${minutes}m ` : ''}${minutes && seconds < 10 ? '0' + seconds : seconds}s`

  const disableResend = limited.manual && !expired

  useEffect(() => {
    if (expired) {
      setError('')
    }
  }, [expired])

  return {
    setLimited,
    setError,
    Resend: resend ? (
      <Component
        center={center}
        fullWidth={fullWidth}
        data-testid={DataTestIds.ResendButton}
        loading={loading}
        disabled={disableResend}
        onClick={resend}
        type="button"
      >{`${error ? t(error) : label} ${
        !expired && limited.manual ? (error ? `${nextResendIn}.` : `(${nextResendIn})`) : ''
      }`}</Component>
    ) : null,
  }
}

export default useResend
